{
    "shortcuts": {
        "dialogType": "table",
        "tableHeadings": [
            "Name",
            "Shortcut",
            "Functions"
        ],
        "tableData": [
            [
                "Search & Accessibility",
                "Alt + S or /",
                "Focus on Search Bar "
            ],
            [
                "Search & Accessibility",
                "Alt + A ",
                "Open Accessibility Options"
            ],
            [
                "Search & Accessibility",
                "Ctrl + + / Ctrl + - ",
                "Zoom In / Zoom Out"
            ],
            [
                "Search & Accessibility",
                "Ctrl + 0",
                "Reset Zoom "
            ],
            [
                "Main Navigation ",
                "Alt + 1 ",
                "Dashboard / Home "
            ],
            [
                "Main Navigation ",
                "Alt + 2 ",
                "Taxpayer Profile "
            ],
            [
                "Main Navigation ",
                "Alt + 3 ",
                "Returns / Filings  "
            ],
            [
                "Main Navigation ",
                "Alt + 4 ",
                "Payments "
            ],
            [
                "Main Navigation ",
                "Alt + 5 ",
                "Reports / Analytics  "
            ],
            [
                "Main Navigation ",
                "Alt + 6 ",
                "Admin Settings  "
            ],
            [
                "Main Navigation ",
                "Alt + Down Arrow  ",
                "Open Dropdown under Nav Item "
            ],
            [
                "Main Navigation ",
                "Tab / Shift + Tab  ",
                "Move between Navigation Items  "
            ],
            [
                "Page Navigation & Sections",
                "Alt + N  ",
                "Next Page  "
            ],
            [
                "Page Navigation & Sections",
                "Alt + P  ",
                "Previous Page  "
            ],
            [
                "Page Navigation & Sections",
                "Alt + O  ",
                "Open Selected Item/Page   "
            ],
            [
                "Page Navigation & Sections",
                "Alt + J  ",
                "Jump to Main Content  "
            ],
            [
                "Page Navigation & Sections",
                "Alt + H ",
                "Jump to Help / FAQ "
            ],
            [
                "Page Navigation & Sections",
                "Alt + F  ",
                "Jump to Footer   "
            ],
            [
                "Page Navigation & Sections",
                "Alt + U   ",
                "Open User Account / Profile   "
            ],
            [
                "Scrolling & Section Navigation ",
                "Space / Shift + Space ",
                "Scroll Down / Scroll Up   "
            ],
            [
                "Scrolling & Section Navigation ",
                "Home / End  ",
                "Scroll to Top / Bottom    "
            ],
            [
                "Scrolling & Section Navigation ",
                "Esc  ",
                "Close Modal / Cancel  "
            ],
            [
                "Scrolling & Section Navigation ",
                "Ctrl + Enter ",
                "Submit Final Return/Form    "
            ],
            [
                "Scrolling & Section Navigation ",
                "Alt + E  ",
                "Edit Selected Item   "
            ],
            [
                "Scrolling & Section Navigation ",
                "Alt + D  ",
                "Delete Selected Item   "
            ],
            [
                "Scrolling & Section Navigation",
                "Alt + R",
                "Refresh Data/Table"
            ],
            [
                "Footer / Utility Items",
                "Alt + C",
                "Contact Us"
            ],
            [
                "Footer / Utility Items",
                "Alt + T",
                "Terms & Conditions"
            ],
            [
                "Footer / Utility Items",
                "Alt + L",
                "Legal / Compliance Links"
            ],
            [
                "Footer / Utility Items",
                "Alt + G",
                "Go to Top of Page"
            ],
            [
                "General Use ",
                "Ctrl + Shift + L",
                "Logout "
            ],
            [
                "General Use ",
                "Ctrl + Shift + D ",
                "Download PDF / Document  "
            ],
            [
                "General Use ",
                "Ctrl + Shift + F ",
                "Full Screen Mode  "
            ],
            [
                "Accessibility & Screen Reader ",
                "Insert + H  ",
                "Screen Reader Help  "
            ]
        ]
    }
}